/*
 * Cyphon header auto-hide on phones and tablets (below 1025px), driven by GSAP: the sticky header slides up while the page scrolls down and eases back
 * down when scrolling stops (or when scrolling up). GSAP is fetched on the first scroll past the header (not on load).
 * Passive scroll listener, one rAF per frame, no layout reads: only window.scrollY. Transform only.
 * Not hidden while a menu, the search or the Help sub-menu is open.
 */
(() => {
  const hdr = document.querySelector('.cy-hdr');
  if (!hdr || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  const bar = hdr.querySelector('#sticky-header');
  const src = document.currentScript && document.currentScript.dataset.gsap;
  if (!bar) return;

  let loading;
  const load = () =>
    window.gsap
      ? Promise.resolve()
      : (loading = loading || new Promise((ok, no) => {
          const s = document.createElement('script');
          s.src = src;
          s.onload = ok;
          s.onerror = no;
          document.head.append(s);
        }));

  const desktop = matchMedia('(min-width:1025px)');
  let hidden = false;
  let lastY = window.scrollY;
  let ticking = false;
  let idle = 0;
  const busy = () => !!hdr.querySelector('.cy-sp-open, .is-open') || document.documentElement.classList.contains('hside_opened');

  const set = (hide) => {
    if (hide === hidden) return;
    if (hide && busy()) return;
    hidden = hide;
    load().then(() => {
      window.gsap.to(bar, {
        y: hide ? -(bar.offsetHeight || 120) : 0,
        duration: hide ? 0.45 : 0.6,
        ease: hide ? 'power2.inOut' : 'expo.out',
        overwrite: 'auto',
        onComplete: hide ? undefined : () => { bar.style.transform = ''; },
      });
    }).catch(() => {});
  };

  // Trackpad and wheel scrolling keep sending small steps after the finger lifts (momentum). Those small steps
  // do not restart the reveal timer, so the bar comes back when the movement actually slows down.
  const frame = () => {
    ticking = false;
    if (desktop.matches) { set(false); return; } // desktop: the header stays put as a capsule (assets/cy-header.css)
    const y = window.scrollY;
    const dy = y - lastY;
    lastY = y;
    if (y < 120) { clearTimeout(idle); idle = 0; set(false); return; }
    if (dy > 6) { // fast scroll down: hide, and keep pushing the reveal back while it lasts
      set(true);
      clearTimeout(idle);
      idle = setTimeout(() => { idle = 0; set(false); }, 260);
    } else if (dy < -2) { // scrolling up: reveal now
      clearTimeout(idle);
      idle = 0;
      set(false);
    } else if (!idle) { // slow movement or stopped: reveal shortly after it settles
      idle = setTimeout(() => { idle = 0; set(false); }, 150);
    }
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
})();
